import { CreateTenderData, TenderAssignmentInput } from '../services/tenderService';
import { Tender } from '../types';

export const TENDER_ASSIGNMENT_STATUS_OPTIONS: NonNullable<TenderAssignmentInput['status']>[] = [
  'PROSPECT',
  'INTERSTED',
  'NOT INTERSTED',
  'EXISTING OTHERS',
  'EXISTING INFRASOL',
  'customer',
];

export function defaultTenderAssignmentRow(): TenderAssignmentInput {
  return { brand_id: undefined as unknown as number, user_id: 0, status: 'PROSPECT' };
}

/** Tender contact first; fall back to master awardee when tender fields are empty. */
export function effectiveAwardeeContactForForm(tender: Tender): {
  awardee_city: string;
  awardee_phone: string;
  awardee_email: string;
} {
  const city = (tender.awardee_city ?? '').trim() || (tender.master_awardee_city ?? '').trim();
  const phone = (tender.awardee_phone ?? '').trim() || (tender.master_awardee_phone ?? '').trim();
  const email = (tender.awardee_email ?? '').trim() || (tender.master_awardee_email ?? '').trim();
  return {
    awardee_city: city,
    awardee_phone: phone,
    awardee_email: email,
  };
}

export function emptyTenderFormData(): CreateTenderData {
  return {
    date: new Date().toISOString().split('T')[0],
    awarder: '',
    awardee_id: undefined,
    assignments: [defaultTenderAssignmentRow()],
  };
}

export function buildCreateTenderDataFromTender(
  fullTender: Tender,
  tenderRow?: Tender
): { formData: CreateTenderData; awardeeName: string } {
  const row = tenderRow ?? fullTender;
  let assignments: TenderAssignmentInput[] =
    fullTender.assignments && fullTender.assignments.length > 0
      ? fullTender.assignments.map((a) => ({
          brand_id: a.brand_id ?? undefined,
          user_id: a.user_id,
          status: a.status as TenderAssignmentInput['status'],
        }))
      : [
          {
            brand_id: row.brand_id ?? undefined,
            user_id: row.assigned_to ?? 0,
            status: row.status as TenderAssignmentInput['status'],
          },
        ];
  if (assignments.length === 0) {
    assignments.push(defaultTenderAssignmentRow());
  }

  const contact = effectiveAwardeeContactForForm(fullTender);

  return {
    awardeeName: fullTender.awardee_name || '',
    formData: {
      date: fullTender.date,
      awarder: fullTender.awarder,
      awardee_id: fullTender.awardee_id ?? undefined,
      awardee_city: contact.awardee_city || undefined,
      awardee_phone: contact.awardee_phone || undefined,
      awardee_email: contact.awardee_email || undefined,
      work_order_value: fullTender.work_order_value,
      industry: fullTender.industry,
      city: fullTender.city,
      scope_of_work: fullTender.scope_of_work,
      completion_months: fullTender.completion_months,
      product_req: fullTender.product_req,
      qty_req: fullTender.qty_req,
      brands_in_use: fullTender.brands_in_use,
      price: fullTender.price,
      source: fullTender.source ?? undefined,
      update_status: fullTender.update_status,
      assignments,
    },
  };
}
